import { Heading, Loader, Text } from "components/common";
import classes from "./ResponseHeader.module.css";
import { Logo, temeLogo } from "images";
import { useAppContext } from "ContextProvider/ContextProvider";
import clsx from "clsx";

const ResponseHeader = ({
  msg,
  firstResponseTime,
  aiCharacter,
  aiCharacters,
  isLoading,
}) => {
  const { myTheme } = useAppContext();

  console.log(msg, "msg");
  console.log(aiCharacters, "aiCharacters");
  return (
    <div className={clsx(classes.header)}>
      {msg?.character && aiCharacters.find((a) => a.id.toLowerCase() == msg?.character.toLowerCase())?.icon ? (
        <img
          src={aiCharacters.find((a) => a.id.toLowerCase() == msg?.character.toLowerCase())?.icon}
          alt="#"
          className={classes.systemLogo}
        />
      ) : (
        <span className={classes.systemLogo}>
           <img src={temeLogo} alt="#" className={classes.logo} />
        </span>
      )}
      <div>
        <Heading primitive50 base medium className={classes.name}>
          {process.env.REACT_APP_AI_RESPONSE_NAME}
          {isLoading && <Loader />}
        </Heading>
        <Text className={classes.info} primitive400>
          {firstResponseTime && firstResponseTime > 0 && (
            <span>{firstResponseTime} sec • </span>
          )}
          {msg?.character
            ? aiCharacters?.find((a) => a.id.toLowerCase() == msg.character.toLowerCase())?.name
            : msg.model}
        </Text>
      </div>
    </div>
  );
};
export default ResponseHeader;
